module.exports = __webpack_public_path__ + "9a5eb2e5a64a12fe3cf7b6436690296a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-RegularItalic.ttf
// module id = 1267
// module chunks = 0